import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { sortQuery } from "./getPropertyList";

export const updateSearchQuery = createAsyncThunk(
  "LeadSavedSearches/updateSearchQuery",
  async (data, thunkAPI) => {
    try {
      let searchParams = {
        ...thunkAPI.getState()?.leads?.savedSearches.searchParams,
      };
      let site_id =
        thunkAPI.getState()?.leads?.savedSearches.searchList.data?.site_id?._id;
      let token =
        thunkAPI.getState()?.leads?.savedSearches.searchList.data?.token;
      let query = "";
      let agentId = data?.agentId ? `?agent=${data.agentId}` : "";
      let hasAssociationYN = false;

      Object.entries(searchParams).forEach(([k, v]) => {
        const isEmpty =
          v === undefined ||
          v === null ||
          v === "" ||
          (v !== false && v !== 0 && !v);

        if (isEmpty) return;

        // if (k === "AssociationYN" && v === true) {
        //   hasAssociationYN = true;
        //   return;
        // }

        if (k !== "sort" && k !== "start" && k !== "rows") {
          // Special City quoting
          const value =
            k === "City" &&
            typeof v === "string" &&
            !v.includes("OR") &&
            v.includes(" ") &&
            !v.includes(`"`)
              ? `"${v}"`
              : v;

          query += query ? ` AND ${k}:${value}` : `${k}:${value}`;
        }
      });

      // If AssociationYN:true, wrap full query in parentheses and OR it
      // if (hasAssociationYN) {
      //   query = query
      //     ? `(${query}) OR AssociationYN:true`
      //     : `AssociationYN:true`;
      // }

      // console.log(query, "query", sortQuery(query), "sortQuery(query)");

      let url = `${process.env.REACT_APP_IDX_BASE_URL}api/v1/properties/${site_id}/${data?.searchId}${agentId}`;
      const resp = await axios.put(
        url,
        {
          q: data?.newQuery
            ? data?.newQuery
            : data?.isAND
            ? query
            : sortQuery(query),
          fq: data?.fq,
          sort: searchParams?.sort,
          start: searchParams?.start,
          rows: searchParams?.rows,
          overwrite: true,
          geoOperator: data?.isAND ? "AND" : "OR",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (resp?.data && data?.handleSuccess) {
        data?.handleSuccess();
      }
      return { ...resp.data, title: data?.title, isAND: data?.isAND };
    } catch (error) {
      if (error.response) {
        if (data?.handleError) {
          data?.handleError(
            error.response.data.errorMessage || error.response.data.message
          );
        }
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        if (data?.handleError) {
          data?.handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
